import { ArchCard } from '@lunary/ui-web/arch-card'
import type { ArchSize } from '@lunary/ui-web/arch-card'
import styles from './card-face.module.css'

type Props = {
  readonly src: string | null | undefined
  readonly number: number | null
  readonly name: string
  readonly size?: Exclude<ArchSize, 'hero'>
}

export function CardFace({ src, number, name, size = 'md' }: Props) {
  if (src) return <img className={`${styles.face} ${styles[size] ?? ''}`} src={src} alt={name} loading="lazy" draggable={false} />
  if (number !== null && number >= 0 && number <= 21) return <ArchCard number={number} name={name} size={size} />
  return (
    <span className={`${styles.face} ${styles.blank} ${styles[size] ?? ''}`} role="img" aria-label={name}>
      {size === 'xs' ? '' : name}
    </span>
  )
}
